// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3OryR","label":"Category_label__2b6qr","content":"Category_content__2w4c6","header":"Category_header__1kDQh","location":"Category_location__RLJ8a"};